/**
 * This is the starting point of your application.
 * oneAudi OS and Feature Hub Apps will use this file to bootstrap the app.
 */
import React from 'react';
import type { Logger } from '@feature-hub/core';
import type { TrackingServiceV2 } from '@oneaudi/audi-tracking-service/dist/v2/types';
import type { TrackingServiceV3 } from '@volkswagen-onehub/oneaudi-os-onesight';
import type { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';
import FeatureAppRoot from './components/FeatureAppRoot';
import type { EditorJsonContent } from './contexts/ContentInterfaces';
import type { TrackingServiceEnvironment } from './utilTrackingHelpers/TrackingHelperWrapper';

export interface FeatureAppProps {
  trackingService?: TrackingServiceV2 | TrackingServiceV3;
  loggerService?: Logger;

  config?: EditorJsonContent;
  environment: string;
  localeService: LocaleServiceV1;
  featureAppId: string;
}
export type TrackingData = {
  trackingService: TrackingServiceEnvironment;
};

const FeatureApp: React.FC<FeatureAppProps> = ({ config, ...inherited }: FeatureAppProps) => {
  const { trackingService, loggerService, environment, localeService, featureAppId } = inherited;

  return (
    <FeatureAppRoot
      environment={environment}
      trackingService={trackingService}
      loggerService={loggerService ?? console}
      config={config}
      localeService={localeService}
      featureAppId={featureAppId}
    />
  );
};
export default FeatureApp;
